// export default () => ({
// })

export default () => ({
    typeproducts: [],
    typeproductsSelectable: [],
    typeproductsPaginatedData: null,
    typeproduct: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null
})